import { Check, Link } from '@phosphor-icons/react';
import { FC, useState } from 'react';

export const VakeShareButton: FC<{ shareValue: string }> = ({ shareValue }) => {
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const handleClick = () => {
        setIsCopied(!isCopied);
        navigator.clipboard.writeText(shareValue);
        setTimeout(() => {
            setIsCopied(false);
        }, 1000);
    };
    if (!isCopied) {
        return <Link color="white" className="cursor-pointer" size={20} onClick={handleClick} />;
    } else {
        return <Check size={20} className="text-success-default" />;
    }
};
